import styled from 'styled-components';

export const CardWrapper = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

export const Title = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

export const Description = styled.div`
  font-size: 12px;
  color: #666666;
  margin: 0 0 12px 0;
  line-height: 1.4;
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #333;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
`;
